import vuetifyMoney from './productDialog.vue'

function install (Vue) {
  Vue.component('product-dialog', vuetifyMoney)
}

export default install
